import React, {useState, useEffect} from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import PropTypes from 'prop-types';


export default function ScheduleBodyHeader(param) {

    const [projectList, setProjectList] = useState([]);
    const [projectId, setProjectId] = useState("-1");
    const [programList, setProgramList] = useState([]);
    const [programId, setProgramId] = useState("-1");
    const [weekSelectCheck, setWeekSelectCHeck] = useState("true");
    const [daySelectCheck, setDaySelectCHeck] = useState("flase");
    const [weekDaySelectCheck, setWeekDaySelectCHeck] = useState("false");
    const [eventSelectCheck, setEventSelectCHeck] = useState("false");
    const [reservedSelectCheck, setReservedSelectCHeck] = useState("false");
    
    async function getProjectList(){

        await axios.get(axiosUrl.project_list)
        .then( response => {
            // old value, new value를 비교하여 변화가 있을 때만, rendering함. 이 로직을 빼면 무한 렌더링에 빠짐.
            if(JSON.stringify(projectList) !== JSON.stringify(response.data)) {
                setProjectList(response.data) ;
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Project.getScheduleList - ' + e);
                console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.project_list);
        });

    }

    useEffect(() => {
        //프로젝트 선택 확인(-1인 경우 아무것도 아닌 값)
        if(projectId !== "") {
            projectList.map((project, i) => {
                if(project.id == projectId) {
                    setProgramList(projectList[i].programs)
                    if(param.programId !== undefined){
                        changeProgram(param.programId);
                    }
                }
            })
        } else {
            setProgramList([]);
        }
    }, [projectId, projectList]); 

    useEffect(() => {
        setProjectId(param.projectId);
        getProjectList();
    }, [param.projectId])

    useEffect(() => {
    }, [programList, programId]); 

    useEffect(() => {
        if(param.type == "RESERVED") {
            setWeekSelectCHeck("nav-link");
            setDaySelectCHeck("nav-link");
            setWeekDaySelectCHeck("nav-link");
            setEventSelectCHeck("nav-link");
            setReservedSelectCHeck('nav-link active');
        } else if(param.type == "DAY") {
            setWeekSelectCHeck("nav-link");
            setDaySelectCHeck("nav-link active");
            setWeekDaySelectCHeck("nav-link");
            setEventSelectCHeck("nav-link");
            setReservedSelectCHeck("nav-link");
        } else if(param.type == "WEEKDAY") {
            setWeekSelectCHeck("nav-link");
            setDaySelectCHeck("nav-link");
            setWeekDaySelectCHeck("nav-link active");
            setEventSelectCHeck("nav-link");
            setReservedSelectCHeck("nav-link");
        } else if(param.type == "EVENT") {
            setWeekSelectCHeck("nav-link");
            setDaySelectCHeck("nav-link");
            setWeekDaySelectCHeck("nav-link");
            setEventSelectCHeck("nav-link active");
            setReservedSelectCHeck("nav-link");
        } else {
            setWeekSelectCHeck("nav-link active");
            setDaySelectCHeck("nav-link");
            setWeekDaySelectCHeck("nav-link");
            setEventSelectCHeck("nav-link");
            setReservedSelectCHeck("nav-link");
        }
    }, [param.type])

    function changeProject(e) {
        setProjectId(e.target.value);
        setProgramId("");
        param.callbackProjectId(e.target.value);
        param.callbackProgramId("");
    }

    function changeProgram(value) {
        setProgramId(value);
        param.callbackProgramId(value);
    }

    function typeSelect(type) {
        param.callbackType(type);
    }

    return(
        <div>
            <div className="programSearch col-md-12">
                <div className="text-right col-md-12">
                    <div className="form-group">
                        <div>
                            <label > 프로젝트명 : </label>
                            <select className="form-control mr-4" onChange={changeProject} value={projectId}>
                                <option value={""} >프로젝트를 선택해주세요</option>
                                {projectList.map((project, i) => (
                                    <option value={project.id} key={i} >{project.name}</option>
                                ))}
                            </select>
                            <label> 프로그램명 : </label>
                            <select className="form-control" onChange={(e) => changeProgram(e.target.value)} value={programId}>
                                <option value={""} >프로그램을 선택해주세요</option>
                                {programList.map((program, i) => (
                                    <option value={program.id} key={i}>{program.name}</option>

                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                {/* position-absolute */}
                <ul className="nav nav-tabs mt-2 col-md-12" id="custom-content-below-tab" role="tablist">
                    <li className="nav-item">
                        <a className={weekSelectCheck} id="custom-content-below-home-tab" data-toggle="pill" href="#custom-content-below-home" role="tab" aria-controls="custom-content-below-home" aria-selected="true" onClick={() => typeSelect("WEEK")}>주</a>
                    </li>
                    <li className="nav-item">
                        <a className={daySelectCheck} id="custom-content-below-profile-tab" data-toggle="pill" href="#custom-content-below-profile" role="tab" aria-controls="custom-content-below-profile" aria-selected="false" onClick={() => typeSelect("DAY")}>일</a>
                    </li>
                    <li className="nav-item">
                        <a className={weekDaySelectCheck} id="custom-content-below-messages-tab" data-toggle="pill" href="#custom-content-below-messages" role="tab" aria-controls="custom-content-below-messages" aria-selected="false" onClick={() => typeSelect("WEEKDAY")}>반복</a>
                    </li>
                    <li className="nav-item">
                        <a className={eventSelectCheck} id="custom-content-below-settings-tab" data-toggle="pill" href="#custom-content-below-settings" role="tab" aria-controls="custom-content-below-settings" aria-selected="false" onClick={() => typeSelect("EVENT")}>이벤트</a>
                    </li>
                    <li className="nav-item">
                        <a className={reservedSelectCheck} id="custom-content-below-settings-tab" data-toggle="pill" href="#custom-content-below-settings" role="tab" aria-controls="custom-content-below-settings" aria-selected="false" onClick={() => typeSelect("RESERVED")}>예약</a>
                    </li>
                </ul>
            </div>
        </div>
    );
}

ScheduleBodyHeader.propTypes = {
    programId: PropTypes.any,
    callbackType: PropTypes.any,
    callbackProgramId: PropTypes.any
  };